import { ApolloError, makeVar } from '@apollo/client';

import { IStudentCourseSavedOnlyId } from '../../operations/query/students/useGetStudentCoursesSavedOnlyCourseId/useGetStudentCoursesSavedOnlyCourseId';

export interface ICoursesSavedOnlyIdCache {
  data: IStudentCourseSavedOnlyId[];
  error: ApolloError | undefined;
}

export const emptyCoursesSavedOnlyIdCache: ICoursesSavedOnlyIdCache = {
  data: [],
  error: undefined,
};

export const coursesSavedOnlyIdVar = makeVar<ICoursesSavedOnlyIdCache>(emptyCoursesSavedOnlyIdCache);
